import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCollectionsGroupByExpand } from "./autogen/AutogenLayoutCollectionsGroupByExpand";
import { ModelRow } from "@mcleod/core";
import { CollectionsUtil } from "./CollectionsUtil";

export class CollectionsGroupByExpand extends AutogenLayoutCollectionsGroupByExpand {
    tableGroupByExpandOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;

        tableRow.forEveryChildComponent((component) => {
            CollectionsUtil.setTooltipContent(component, modelRow);
        });
    }
}
